import { render, staticRenderFns } from "./SelectDesktop.vue?vue&type=template&id=41692085&scoped=true"
import script from "./SelectDesktop.vue?vue&type=script&lang=js"
export * from "./SelectDesktop.vue?vue&type=script&lang=js"
import style0 from "./SelectDesktop.vue?vue&type=style&index=0&id=41692085&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41692085",
  null
  
)

export default component.exports